module.exports = __webpack_public_path__ + "static/media/daily-substituion-record.53d05b4f.svg";